import { Image } from '@cian/ui-kit';
import { ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { getPromoIcon } from './utils';
import { EType } from '../../../../types/villagePromotions';

interface IPromoItemProps {
  promoType: EType;
  title: string;
  onClick(): void;
  subtitle?: string;
  icon?: string;
}

export const PromoItem: React.FC<IPromoItemProps> = ({ promoType, title, onClick, subtitle, icon }) => {
  return (
    <div className={styles['container']} id="test2" onClick={onClick}>
      <div className={styles['icon']}>{icon ? <Image src={icon} title="Иконка акции" /> : getPromoIcon(promoType)}</div>
      <div className={styles['text']}>
        <div className={styles['title']}>
          <ArticleParagraph2 fontWeight="bold">{title}</ArticleParagraph2>
        </div>
        {subtitle && (
          <div className={styles['subtitle']}>
            <ArticleParagraph3 color="gray60_100">{subtitle}</ArticleParagraph3>
          </div>
        )}
      </div>
    </div>
  );
};
